var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZeeNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 4306.79 2001.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1317.9,
    y1: 1475.74,
    x2: 3287.04,
    y2: 1475.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0232a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df1f29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3053.83,
    y1: 1371.83,
    x2: 3317.97,
    y2: 1371.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3053.33,
    y1: 1574.38,
    x2: 3317.9,
    y2: 1574.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 3431.35,
    y1: 1474.41,
    x2: 3872.04,
    y2: 1474.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 3998.46,
    y1: 1474.41,
    x2: 4377.03,
    y2: 1474.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 4439.88,
    y1: 1475.5,
    x2: 5194.11,
    y2: 1475.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 5233.12,
    y1: 1474.41,
    x2: 5624.69,
    y2: 1474.41,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zee News") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1001.69,
    cy: 1000.1,
    r: 999.31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2942.79,1727.28V1221.56h343.53c-112.48-429.47-503.16-746.34-967.9-746.34-552.57,0-1000.52,447.95-1000.52,1000.52s447.95,1000.52,1000.52,1000.52c465.69,0,857.06-318.17,968.62-749Zm-635.31-421.19-278.15,323.66h278.15v97.53h-421.2v-84.53l278.15-323.66H1895v-97.53h412.53Zm501.4,14.44H2534.35v102.59h274.53v99H2534.35v106.2h274.53v99H2423.81V1221.56h385.07Z",
    transform: "translate(-1317.9 -475.22)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3053.83,1320.53v102.59l264.14-1.63a1006.74,1006.74,0,0,0-10.52-101Z",
    transform: "translate(-1317.9 -475.22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3053.33,1628.3h254.05a1006.32,1006.32,0,0,0,10.52-107.83l-264.57,1.63Z",
    transform: "translate(-1317.9 -475.22)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3431.35,1221.56h82.36l270.92,349.66V1221.56H3872v505.71h-74.41l-278.86-359.78v359.78h-87.42Z",
    transform: "translate(-1317.9 -475.22)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M3998.46,1221.56h374.95V1301H4087.33v131.48H4340.9V1512H4087.33V1647.8H4377v79.47H3998.46Z",
    transform: "translate(-1317.9 -475.22)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M4439.88,1221.56H4536l120.65,375,124.26-376.4H4856l124.26,376.4,120.65-375h93.2l-176.28,509.32h-76.58L4817,1367.49l-124.26,363.39h-76.58Z",
    transform: "translate(-1317.9 -475.22)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M5233.12,1653.58l53.46-63.58c48.41,41.91,96.81,65.75,159.66,65.75,54.91,0,89.59-25.29,89.59-63.58v-1.44c0-36.12-20.23-55.63-114.15-77.3-107.64-26-168.33-57.8-168.33-151V1361c0-86.69,72.25-146.66,172.67-146.66,73.69,0,132.2,22.4,183.5,63.58l-47.68,67.19c-45.52-34-91-52-137.27-52-52,0-82.36,26.73-82.36,60v1.45c0,39,23.12,56.35,119.93,79.47,106.92,26,162.55,64.29,162.55,148.1v1.44c0,94.64-74.41,151-180.61,151C5366.78,1734.49,5293.81,1707.76,5233.12,1653.58Z",
    transform: "translate(-1317.9 -475.22)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeeNews);
export default __webpack_public_path__ + "static/media/zee-news.fa8dd17ce7a1e2141ab971316126408b.svg";
export { ForwardRef as ReactComponent };